import { render, staticRenderFns } from "./subscriptionSettings.vue?vue&type=template&id=773f209e&scoped=true"
import script from "./subscriptionSettings.vue?vue&type=script&lang=js"
export * from "./subscriptionSettings.vue?vue&type=script&lang=js"
import style0 from "./subscriptionSettings.vue?vue&type=style&index=0&id=773f209e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f209e",
  null
  
)

export default component.exports